import { t } from "@/i18n-js/instance";
import type { UpdateMobileHomeSegmentsPayload } from "@/react/api/mobileHomeSegmentsApi";
import type { MobileHomeSegment } from "@/react/types/MobileHomeSegment";
import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";
import { ConfirmationModal } from "@circle-react-shared/ModalsV2/ConfirmationModal";
import { Form } from "@circle-react-uikit/Form";
import { useToast } from "@circle-react-uikit/ToastV2";
import { useUpdateMobileHomeSegment } from "../hooks/useUpdateMobileHomeSegment";

const i18nRoot = "settings.mobile_app.mobile_home_segments_order.rename_modal";

interface RenameModalContentProps {
  segment: MobileHomeSegment;
}
export const RenameModalContent = ({ segment }: RenameModalContentProps) => {
  const modal = useModal();
  const toast = useToast();

  const onSuccess = () => {
    toast.success(t([i18nRoot, "success"]));
    void modal.hide();
  };
  const { mutate, isUpdating } = useUpdateMobileHomeSegment({ onSuccess });

  const handleSubmit = (payload: UpdateMobileHomeSegmentsPayload) => {
    mutate({ id: segment.id, payload });
  };

  return (
    <ConfirmationModal
      formId="rename-segment-modal"
      isOpen={modal.visible}
      onClose={modal.hide}
      title={t([i18nRoot, "title"])}
      confirmVariant="circle"
      confirmText={t([i18nRoot, "save"])}
      disabled={isUpdating}
    >
      <Form
        id="rename-segment-modal"
        defaultValues={{ custom_name: segment.custom_name }}
        onSubmit={handleSubmit}
      >
        <Form.Item
          name="custom_name"
          translationRoot={i18nRoot}
          tooltipText={t([i18nRoot, "custom_name_tooltip"])}
          hideDescription
          hidePlaceholder
          hideBorder
        >
          <Form.Input name="custom_name" maxLength={255} autocomplete="off" />
        </Form.Item>
      </Form>
    </ConfirmationModal>
  );
};

const RenameModal = ModalManager.create((props: RenameModalContentProps) => (
  <RenameModalContent {...props} />
));

export const useRenameFormModal = () => useModal(RenameModal);
